import { get, post, postForm, getBlob } from "../common/dataFetch";

export const addLoanInBatch = (interimLoanStagingId : number) => {
    return post<any>("InterimToEncompass/AddLoanInBatch", interimLoanStagingId);
};
